// extracted by mini-css-extract-plugin
export var errorPage = "styles-module--errorPage--Vc-8w";